// Shared by prompt and skill collection share dialogs — keep out of feature-specific folders.

import { getShareUrlOverride } from "@/utils/env";

const VIBES_BASE_URL = getShareUrlOverride() || "https://share.promptlayer.com";

export enum ShareDialogMode {
  CREATE = "create",
  MANAGE = "manage",
  CREATED = "created",
}

export const sessionUrl = (token: string) => `${VIBES_BASE_URL}/${token}`;

/* ─── Spring configs ─── */
export const springSnappy = {
  type: "spring" as const,
  stiffness: 600,
  damping: 38,
  mass: 0.6,
};

export const springGentle = {
  type: "spring" as const,
  stiffness: 500,
  damping: 36,
  mass: 0.6,
};

/* ─── Shared animation variants ─── */
export const fadeSlideVariants = {
  initial: { opacity: 0, y: 4 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -3 },
};

/** Stagger delay per row index for manage-session list motion. */
export const SESSION_ROW_STAGGER_DELAY = 0.04;
